import React, {} from 'react';

import application from 'application';

import './index.scss';

function LoggedOutView() {

  const loginButtonAttributes = {
    id: 'login-again-button',
    className: 'startup-themed-button startup-button-color startup-text-color',
    href: application.getAuthenticatorURL() + getAuthenticatorQueryString()
  };

  function getAuthenticatorQueryString() {

    return `?origin=${window.location.host}&path=/&observerId=${application.startupUserObserver.getObserverId()}`;

  }

  return <div id="logged-out-view-main">

    <p id="logged-out-view-message">You are successfully logged out!</p>

    <a {...loginButtonAttributes}>Login Again</a>
    
  </div>;

}

export default LoggedOutView;